module.exports = __webpack_public_path__ + "static/media/block-time-icon.4febc068.svg";